import { render, staticRenderFns } from "./ContactStore.vue?vue&type=template&id=43a4c0a4&scoped=true&"
import script from "./ContactStore.vue?vue&type=script&lang=ts&"
export * from "./ContactStore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a4c0a4",
  null
  
)

export default component.exports